<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3 flex flex-row gap-4 items-center">
  <div class="flex items-center gap-3 my-3">
    <app-back-option-section [loading]="loading"></app-back-option-section>
    <h2>Customer Details - {{this.customerData.customerId}}</h2>
  </div>
</div>
<nz-tabset *appHasAnyPrivilege="'CUSTOMER_SINGLE_VIEW'" [(nzSelectedIndex)]="activeTabIndex">
  <nz-tab nzTitle="Customer Information">

    <div [ngClass]="!loading ? 'block' : 'hidden'">
      <section id="customerDetails" class="mt-5">

        <div class="w-full flex justify-start mb-4">
          <button *appHasAnyPrivilege="'CUSTOMER_UPDATE'" class="sm:hidden custom-btn-edit-details" nz-button nzType="primary"
                  style="max-width: 120px" (click)="editNavigate()">Edit Details
          </button>
        </div>

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Customer Details</h5>
              <button *appHasAnyPrivilege="'CUSTOMER_UPDATE'" class="sm:block hidden" nz-button nzType="primary"
                      style="max-width: 120px" (click)="editNavigate()">Edit Details
              </button>
            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Full Name</p>
                    <p
                      class="subject-data">{{ customerData.renterDetails.fullName ? (selectedTitle(customerData.renterDetails.title) +' '+ customerData.renterDetails.fullName) : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Email</p>
                    <p
                      class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="mailto:{{ customerData.renterDetails.email ? (customerData.renterDetails.email) : '-' }}">{{ customerData.renterDetails.email ? (customerData.renterDetails.email) : '-' }}</a></p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Country</p>
                    <p
                      class="subject-data">{{ customerData.renterDetails.homeCountry ? (customerData.renterDetails.homeCountry) : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Contact Number</p>
                    <p
                      class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="tel:{{ customerData.renterDetails.contactNo ? (customerData.renterDetails.contactNo) : '-' }}">{{ customerData.renterDetails.contactNo ? (selectedDailNumber(customerData.renterDetails.dailCode) + ' ' + customerData.renterDetails.contactNo) : '-' }}</a></p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Date of Birth</p>
                    <p
                      class="subject-data">{{ customerData.renterDetails.dob ? (customerData.renterDetails.dob | date:'yyyy-MM-dd') : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Birth City</p>
                    <p
                      class="subject-data">{{ customerData.renterDetails.birthCity ? (customerData.renterDetails.birthCity) : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Birth Country</p>
                    <p
                      class="subject-data">{{ customerData.renterDetails.birthCountry ? (customerData.renterDetails.birthCountry) : '-' }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Home Address</p>
                    <p
                      class="subject-data">{{ customerData.renterDetails.homeAddress ? (customerData.renterDetails.homeAddress) : '-' }}</p>
                  </div>

                </div>
              </div>

              <div>

              </div>

            </div>
          </div>
        </nz-card>
      </section>

      <section id="passportDetails" class="mt-5">
        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Passport / Licence Details</h5>
            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <h5 class="mb-2">Passport</h5>
                  <div class="item-row">
                    <p class="subject-name">Passport Number</p>
                    <p
                      class="subject-data">{{ customerData.passportLicenceDetails.passportNo ? (customerData.passportLicenceDetails.passportNo) : '-' }}</p>

                  </div>
                  <div class="item-row">
                    <p class="subject-name">Passport Issued Date</p>
                    <p
                      class="subject-data">{{ customerData.passportLicenceDetails.issueDatePass ? (customerData.passportLicenceDetails.issueDatePass | date:'yyyy-MM-dd') : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Passport Expiry Date</p>
                    <p
                      class="subject-data">{{ customerData.passportLicenceDetails.expiryDatePass ? (customerData.passportLicenceDetails.expiryDatePass | date:'yyyy-MM-dd') : '-' }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <h5 class="mb-2">Licence</h5>
                  <div class="item-row">
                    <p class="subject-name">Licence Number</p>
                    <p
                      class="subject-data">{{ customerData.passportLicenceDetails.drivingLicenceNo ? customerData.passportLicenceDetails.drivingLicenceNo : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Licence Issued Date</p>
                    <p
                      class="subject-data">{{ customerData.passportLicenceDetails.issueDateLicence ? (customerData.passportLicenceDetails.issueDateLicence | date:'yyyy-MM-dd') : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Licence Expiry Date</p>
                    <p
                      class="subject-data">{{ customerData.passportLicenceDetails.expiryDateLicence ? (customerData.passportLicenceDetails.expiryDateLicence | date:'yyyy-MM-dd') : '-' }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Licence Issued Country</p>
                    <p
                      class="subject-data">{{ customerData.passportLicenceDetails.issuedCountryLicence ? customerData.passportLicenceDetails.issuedCountryLicence : '-' }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="mt-2" *ngFor="let item of customerData.passportLicenceFiles">
                    <a [href]="item.url" class="flex" target="_blank">
                      <img src="assets/img/file.png" height="20" width="20" alt="file">
                      <p class="pl-3">{{item.name}}</p>
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>


  </nz-tab>

    <nz-tab *appHasAnyPrivilege="'CUSTOMER_TOUR_DETAILS_VIEW'" nzTitle="Booking Records">

      <section class="my-3">

        <nz-card>
          <div class="flex flex-col gap-3">
            <div [ngClass]="loadingTable ? 'hidden' : 'block'">
              <nz-collapse>
                <nz-collapse-panel [nzHeader]="'Advanced Search'">
                  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                    <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton" style="width: auto">
                        <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input placeholder="Search here"/>
                      </nz-input-group>

                      <ng-template #suffixIconSearchButton>
                        <button nz-button nzType="primary" nzSearch (click)="search()" class="bg-[#6B6C6E] border-[#6B6C6E]">
                          <span nz-icon nzType="search"></span>
                        </button>
                      </ng-template>
                      <nz-divider
                        class="hidden lg:block"
                        [nzType]="'vertical'"
                      ></nz-divider>

                      <div class="flex w-full lg:w-auto  flex-col lg:flex-row lg:items-center">
                        <nz-form-label class="flex">Filter By Status</nz-form-label>

                        <nz-select
                          [(ngModel)]="statusFilter"
                          (ngModelChange)="search()"
                          nzPlaceHolder="Select Status"
                          [nzAllowClear]="true"
                        >
                          <nz-option nzLabel="Reservation" nzValue="RESERVATION"></nz-option>
                          <nz-option nzLabel="On Transfer" nzValue="ON_TRANSFER"></nz-option>
                          <nz-option nzLabel="On Rent" nzValue="ON_RENT"></nz-option>
                          <nz-option nzLabel="Completed" nzValue="COMPLETED"></nz-option>
                          <nz-option nzLabel="Cancelled" nzValue="CANCELLED"></nz-option>
                        </nz-select>
                        <nz-divider
                          class="hidden lg:block"
                          [nzType]="'vertical'"
                        ></nz-divider>
                      </div>
                      <nz-range-picker [(ngModel)]="dateFilter" (ngModelChange)="onChangeDateFilter($event)"></nz-range-picker>
                      <!--                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>-->
                      <!--                <div class="flex gap-2">-->
                      <!--                  <button nz-button nzType="default" class="rounded-full">Arrival</button>-->
                      <!--                  <button nz-button nzType="default" class="rounded-full">Departure</button>-->
                      <!--                </div>-->
                    </div>
                    <div>
                      <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                        Reset All
                      </button>
                    </div>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>

            <div [ngClass]="loadingTable ? 'hidden' : 'block'" class="table-card mt-4">
              <div class="table-obj">
                <nz-table
                  #basicTable [nzData]="bookingData" [nzShowSizeChanger]="pageSize.length > 5"
                  [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                  [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                  (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto' }"
                  nzOuterBordered class="table-wSpace-nowrap"
                >
                  <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Booking Type</th>
                    <th>Driver Name</th>
                    <th>Booking Start Date and Time</th>
                    <th>Booking End Date and Time</th>
                    <th>Booking Status</th>
                    <th>Vehicle Reg Number</th>
                    <th>Agent</th>
                    <th>Agent Booking Reference</th>
                  </tr>

                  </thead>
                  <tbody>

                  <ng-container
                    *ngFor="let data of basicTable.data"
                    class="align-baseline"
                  >

                  <tr>
                    <td>
                      <span  (click)="navigate(data)" class="clickable-element" *ngIf="data.bookingType === 'transfer'">{{data.transferId}}</span>
                      <span  (click)="navigate(data)" class="clickable-element" *ngIf="data.bookingType === 'rent'">{{data.refNo}}</span>
                    </td>
                    <td *ngIf="data.bookingType === 'rent'">Rent</td>
                    <td *ngIf="data.bookingType === 'transfer'">Transfer</td>

                    <td *ngIf="data.bookingType === 'rent'">{{data.allocationDetails?.allocatedDriver ? data.allocationDetails?.allocatedDriver?.fullName :  '-'}}</td>
                    <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocateDriver">{{data.departureDetails?.allocateDriver?.fullName}}</td>
                    <td *ngIf="data.bookingType === 'transfer' && !(data.arrivalDetails.allocateDriver && data.departureDetails.allocateDriver)">{{data.arrivalDetails?.allocateDriver?.fullName}}</td>


                    <td *ngIf="data.bookingType === 'rent'">{{ data.tourDetails.arrivalInformation ? (data.tourDetails.arrivalInformation.arrivalDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.arrivalInformation.arrivalTime | date:'hh:mm a') : '-' }}</td>
                    <td *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Arrival' ">{{ data.tourDetails ? (data.tourDetails.arrivalFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.pickUpTime | date:'hh:mm a') : '-' }}</td>
                    <td *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Departure'">{{ data.tourDetails.departureTourDetails.departureFlightDate ? (data.tourDetails.departureTourDetails.departureFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departurePickUpTime | date:'hh:mm a') : '-' }}</td>

                    <td *ngIf="data.bookingType === 'rent'">{{ data.tourDetails.departureInformation ? (data.tourDetails.departureInformation.departureDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureInformation.departureDate | date:'hh:mm a') : '-' }}</td>
                    <td *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Departure'">{{ data.tourDetails.departureTourDetails.departureEndDate ? (data.tourDetails.departureTourDetails.departureEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departureEndTime | date:'hh:mm a') : '-' }}</td>
                    <td *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Arrival' ">{{ data.tourDetails ? (data.tourDetails.arrivalEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.arrivalEndTime | date:'hh:mm a') : '-' }}</td>

                    <td>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'COMPLETED') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'COMPLETED' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'COMPLETED' && data.bookingDetails.bookingCategory === 'Departure')" [nzColor]="'#3ab200'"
                              class="rounded-full"
                      >Completed
                      </nz-tag
                      >
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'CANCELLED') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'CANCELLED' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'CANCELLED' && data.bookingDetails.bookingCategory === 'Departure')"
                      class="rounded-full" [nzColor]="'#F3454C'"
                      >Cancelled
                      </nz-tag>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'RESERVATION') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'RESERVATION' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'RESERVATION' && data.bookingDetails.bookingCategory === 'Departure')"

                        [nzColor]="'#FF8C00'" class="rounded-full"
                      >Reservation
                      </nz-tag>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'ON_RENT') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'ON_RENT' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'ON_RENT' && data.bookingDetails.bookingCategory === 'Departure')"
                        [nzColor]="'#4655f5'" class="rounded-full"
                      >On Rent
                      </nz-tag>
                      <nz-tag
                        *ngIf="(data.bookingType !== 'transfer' && data?.status === 'ON_TRANSFER') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'ON_TRANSFER' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'ON_TRANSFER' && data.bookingDetails.bookingCategory === 'Departure')"
                        [nzColor]="'#4655f5'" class="rounded-full"
                      >On Transfer
                      </nz-tag>
                    </td>
                    <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocateVehicle && data.bookingDetails.bookingCategory === 'Departure'">{{data.departureDetails?.allocateVehicle?.vehicleDetails?.registrationNumber}}</td>
                    <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocatedVehicle && data.bookingDetails.bookingCategory === 'Departure'">{{data.departureDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber}}</td>
                    <td *ngIf="data.bookingType === 'transfer' && data.arrivalDetails.allocateVehicle">{{data.arrivalDetails?.allocateVehicle?.vehicleDetails?.registrationNumber}}</td>
                    <td *ngIf="data.bookingType === 'transfer' && data.arrivalDetails.allocatedVehicle ">{{data.arrivalDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber}}</td>

                    <td *ngIf="data.bookingType === 'rent' && data.allocationDetails?.allocatedVehicle ">{{data.allocationDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber}}</td>
                    <td *ngIf="data.bookingType === 'rent' && data.allocationDetails.allocatedDriverVehicle ">{{data.allocationDetails?.allocatedDriverVehicle?.vehicleDetails?.registrationNumber}}</td>
                    <td *ngIf="data.bookingType === 'rent' && !data.allocationDetails.allocatedDriverVehicle && !data.allocationDetails?.allocatedVehicle">-</td>


                    <td *ngIf="data.bookingType === 'transfer'">{{data.bookingDetails.agent ? data.bookingDetails.agent?.name : '-' }}</td>
                    <td *ngIf="data.bookingType === 'rent'">{{ data.bookingDetails.agent ?  data.bookingDetails.agent?.name  : '-' }}</td>

                    <td *ngIf="data.bookingType === 'transfer'">{{ data.bookingDetails.bookingReference ?  data.bookingDetails.bookingReference  : '-' }}</td>
                    <td *ngIf="data.bookingType === 'rent'">{{ data.bookingDetails.bookingReferenceNo ?  data.bookingDetails.bookingReferenceNo  : '-' }}</td>
                  </tr>

                    <ng-container
                      *ngIf="data.bookingType === 'transfer' && (data.bookingDetails.bookingCategory === 'Arrival' && data.tourDetails.departureCheck)">

                      <tr>
                        <td>
                          <span  (click)="navigate(data)" class="clickable-element" *ngIf="data.bookingType === 'transfer'">{{data.transferId}}</span>

                        </td>

                        <td *ngIf="data.bookingType === 'transfer'">Transfer</td>

                          <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocateDriver">{{data.departureDetails?.allocateDriver?.fullName}}</td>



                         <td *ngIf="data.bookingType === 'transfer'">{{ data.tourDetails.departureTourDetails.departureFlightDate ? (data.tourDetails.departureTourDetails.departureFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departurePickUpTime | date:'hh:mm a') : '-' }}</td>

                         <td *ngIf="data.bookingType === 'transfer'">{{ data.tourDetails.departureTourDetails.departureEndDate ? (data.tourDetails.departureTourDetails.departureEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departureEndTime | date:'hh:mm a') : '-' }}</td>

                        <td>
                          <nz-tag *ngIf="data?.departureDetails.status === 'COMPLETED'" [nzColor]="'#3ab200'"
                                  class="rounded-full"
                          >Completed
                          </nz-tag
                          >
                          <nz-tag
                            *ngIf="data?.departureDetails.status === 'CANCELLED'" class="rounded-full" [nzColor]="'#F3454C'"
                          >Cancelled
                          </nz-tag>
                          <nz-tag
                            *ngIf="data?.departureDetails.status === 'RESERVATION'"
                            [nzColor]="'#FF8C00'" class="rounded-full"
                          >Reservation
                          </nz-tag>
                          <nz-tag
                            *ngIf="data?.departureDetails.status === 'ON_RENT'"
                            [nzColor]="'#4655f5'" class="rounded-full"
                          >On Rent
                          </nz-tag>
                          <nz-tag
                            *ngIf="data?.departureDetails.status === 'ON_TRANSFER' "
                            [nzColor]="'#4655f5'" class="rounded-full"
                          >On Transfer
                          </nz-tag>
                        </td>
                        <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocateVehicle">{{data.departureDetails?.allocateVehicle?.vehicleDetails?.registrationNumber}}</td>
                        <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocatedVehicle">{{data.departureDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber}}</td>

                        <td *ngIf="data.bookingType === 'transfer'">{{data.bookingDetails.agent ? data.bookingDetails.agent?.name : '-' }}</td>

                        <td *ngIf="data.bookingType === 'transfer'">{{ data.bookingDetails.bookingReference ?  data.bookingDetails.bookingReference  : '-' }}</td>
                          </tr>
                    </ng-container>

                    </ng-container>
                  </tbody>
                </nz-table>
              </div>
            </div>
            <div [ngClass]="loadingTable ? 'block' : 'hidden'">
              <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
            </div>



          </div>
        </nz-card>
      </section>


    </nz-tab>
  <!--  <nz-tab nzTitle="Allocated Vehicles">-->

  <!--  </nz-tab>-->
  <!--  <nz-tab nzTitle="Departure">-->

  <!--  </nz-tab>-->
  <!--  <nz-tab nzTitle="Payment Records">-->

  <!--  </nz-tab>-->
    <nz-tab *appHasAnyPrivilege="'CUSTOMER_NOTE_ATTACHMENT_NOTES_VIEW,CUSTOMER_NOTE_ATTACHMENT_ATTACHMENTS_VIEW'" nzTitle="Notes and Attachments">

      <section id="notesAndAttachments">
        <nz-card>

          <div [ngClass]="!loading ? 'block' : 'hidden'" class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8 mb-10">

            <div *appHasAnyPrivilege="'CUSTOMER_NOTE_ATTACHMENT_NOTES_VIEW'">
              <div class="flex -align-center mb-5">
                <p class="font-semibold mr-5">Notes</p>
                <span *appHasAnyPrivilege="'CUSTOMER_NOTE_ATTACHMENT_NOTES_UPDATE'" nz-icon nzType="edit" (click)="showModal()"
                      class="mt-0.5 clickable-element" nzTheme="outline"></span>
              </div>
              <textarea class="mt-2" rows="8" nz-input id="disabledTextarea" disabled [(ngModel)]="inputValue"></textarea>

            </div>

            <div *appHasAnyPrivilege="'CUSTOMER_NOTE_ATTACHMENT_ATTACHMENTS_VIEW'" class="sub-section" style="height: 100%">
              <div class="flex justify-between items-center flex-col md:flex-row">
                <p class="font-semibold mb-2 md:mb-0">Attachments</p>
                <nz-upload [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="true">
                  <button *appHasAnyPrivilege="'CUSTOMER_NOTE_ATTACHMENT_ATTACHMENTS_CREATE'" nz-button nzType="primary">Add
                    Attachment
                  </button>
                </nz-upload>
              </div>
              <nz-divider></nz-divider>
              <div>
                <div *ngIf="!uploading">
                  <div class="mb-3 flex  items-center mx-3 gap-5" *ngFor="let item of this.files; let i = index">
                    <a target="_blank" href="{{item.url}}">{{item.name}}</a>
                    <span *appHasAnyPrivilege="'CUSTOMER_NOTE_ATTACHMENT_ATTACHMENTS_DELETE'" nz-icon nzType="close-circle"
                          nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                          class="cursor-pointer" nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this attachment"
                          (nzOnConfirm)="confirmRemoveAttachment(i)"
                    ></span>
                  </div>
                </div>
                <div *ngIf="uploading" class="flex justify-center">
                  <p class="text-primary">Uploading...</p>
                </div>

              </div>
            </div>


          </div>

          <div [ngClass]="loading ? 'block' : 'hidden'">
            <app-single-view-skeleton-template [typeName]="'note-view'"></app-single-view-skeleton-template>
          </div>

        </nz-card>
      </section>


      <nz-modal
        [(nzVisible)]="isVisible"
        [nzTitle]="modalTitle"
        [nzContent]="modalContent"
        [nzFooter]="modalFooter"
        (nzOnCancel)="handleCancel()"
      >
        <ng-template #modalTitle>Create Note</ng-template>

        <ng-template #modalContent>
          <textarea class="mt-2" rows="5" nz-input class="mt-5 mb-5" [(ngModel)]="tempInputVal"></textarea>
        </ng-template>

        <ng-template #modalFooter>
          <button nz-button class="outline-button" (click)="handleCancel()">Cancel</button>
          <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="loading">Update</button>
        </ng-template>
      </nz-modal>


    </nz-tab>
</nz-tabset>
